/**
 * Stacking order for a dialog that must open over the Veivo walk-around.
 *
 * On a phone or touch device the SDK makes the walk-around full-screen at
 * z-index 2147483000 (DEV-1806), so a dialog at the default z-50 — help,
 * "Finish later?" — would open behind the camera: invisible, with the page
 * already inert under it.
 */
export const ABOVE_VEIVO_WALK_AROUND = "z-[2147483646]";
